'use client'

import { useEffect, useState } from 'react'
import Script from 'next/script'

import { usePathname } from '@/i18n/navigation'

/**
 * Klaviyo 插件
 */
const Klaviyo = () => {
  const pathName = usePathname()

  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    if (loaded) {
      setTimeout(() => {
        if (pathName !== '/') {
          const klEl = document.querySelectorAll(`
            .needsclick[class*=" kl-teaser-"]
          `)
          if (klEl.length && klEl[0]) {
            const el = klEl[0] as HTMLElement
            el.style.display = 'none'
          }
        }

        const klEl = document.querySelectorAll(`
          .needsclick[class*=" kl-teaser-"]
        `)
        if (klEl.length && klEl[0]) {
          const el = klEl[0] as HTMLElement
          el.style.display = 'block'
        }
      }, 500)
    }

    return () => {
      const klEl = document.querySelectorAll(`
        .needsclick[class*=" kl-teaser-"]
      `)
      if (klEl.length && klEl[0]) {
        const el = klEl[0] as HTMLElement
        el.style.display = 'none'
      }
    }
  }, [loaded, pathName])

  if (!process.env.NEXT_PUBLIC_KLAVIYO_ID) {
    return null
  }

  return (
    <Script
      strategy="lazyOnload"
      src={`https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${process.env.NEXT_PUBLIC_KLAVIYO_ID}`}
      onLoad={() => setLoaded(true)}
    />
  )
}

export default Klaviyo
